export function isEmptyString(str: string) {
  return str.trim().length === 0;
}
